const Terms = () => (
  <div className="max-w-3xl mx-auto space-y-6">

    <h1 className="font-display text-2xl md:text-3xl font-bold tracking-tight">Terms of Service</h1>
    {/* Update this date manually whenever the terms content changes. */}
    <p className="text-sm text-muted-foreground">Last updated: 18 April 2026</p>

    <div className="prose prose-sm dark:prose-invert max-w-none space-y-4">
      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">1. Acceptance of Terms</h2>
        <p className="text-muted-foreground">
          By accessing or using EmbedKit ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not use the Service.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">2. Description of Service</h2>
        <p className="text-muted-foreground">
          EmbedKit provides free, client-side embeddable widgets (calculators, converters, and utilities) that website owners can add to their websites. All widgets run entirely in the end user's browser.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">3. Free Use</h2>
        <p className="text-muted-foreground">
          EmbedKit widgets are provided free of charge for both personal and commercial use. You may embed our widgets on any website without restriction. No attribution is required, though it is appreciated.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">4. No Warranty</h2>
        <p className="text-muted-foreground">
          The Service is provided "as is" and "as available" without warranty of any kind, express or implied. We do not guarantee the accuracy of calculations, currency rates, prayer times, or any other data provided by our widgets or the third-party APIs they consume.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">5. Limitation of Liability</h2>
        <p className="text-muted-foreground">
          To the maximum extent permitted by law, Synergaid Pty Ltd shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, or goodwill, arising out of your use of the Service.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">6. Third-Party Services</h2>
        <p className="text-muted-foreground">
          Some widgets rely on third-party APIs for data (exchange rates, gold prices, prayer times, QR code generation). We are not responsible for the availability, accuracy, or terms of these third-party services.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">7. Modifications</h2>
        <p className="text-muted-foreground">
          We reserve the right to modify, suspend, or discontinue the Service at any time without notice. We may also update these Terms from time to time. Continued use of the Service after any changes constitutes acceptance of the new terms.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">8. Governing Law</h2>
        <p className="text-muted-foreground">
          These Terms shall be governed by and construed in accordance with the laws of New South Wales, Australia, without regard to its conflict of law provisions.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">9. Contact</h2>
        <p className="text-muted-foreground">
          For questions about these Terms, please contact us at{" "}
          <a href="https://synergaid.com.au" target="_blank" rel="noopener noreferrer" className="text-primary underline">
            synergaid.com.au
          </a>.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-display text-lg font-semibold">10. Operator</h2>
        <p className="text-muted-foreground">
          EmbedKit is operated by Synergaid Pty Ltd (ABN: 63 682 263 001), an Australian company.
        </p>
      </section>
    </div>
  </div>
);

export default Terms;
